import React, { useEffect, useState } from 'react'
import SuperAdminHeader from './SuperAdminHeader'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { config } from '../../function/config'
import { toast } from 'react-toastify'

export default function AssignBranch() {

  const { id } = useParams()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')

  const [branch, setBranch] = useState(null)
  const [admins, setAdmins] = useState([])
  const [selectedAdmin, setSelectedAdmin] = useState('')
  const [loading, setLoading] = useState(false)

  // Fetch Selected Branch
  const fetchBranch = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_branch/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Selected Branch:', res.data)

      if(res.status === 200){
        setBranch(res.data.data)
      }else{
        toast.error('Failed to fetch selected branch')
      }
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  const fetchAdmins = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_available_admins/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('All Admins:', admins)

      if(res.status === 200){
        setAdmins(res.data.data)
      }else{
        toast.error('Fails to fetcg admin data')
      }
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to fetch admin'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchBranch()
    fetchAdmins()
  },[id])

  const handleAssign = async(e) => {
    e.preventDefault()

    if(!selectedAdmin){
      toast.error('Please select admin')
      return
    }

    setLoading(true)

    try{
      console.log('Branch Id:', id)
      console.log('Selected Admin Id:', selectedAdmin)

      const res = await axios.put(`${config.baseurl}assign_branch_to_admin/${id}/`, {admin_id:selectedAdmin}, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      if(res.status === 200){
        toast.success(res.data.message)
        navigate(`/super_admin/pending_branch_allocation`)
      }else{
        toast.error('Failed to assign branch to admin')
      }
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to asign branch to admin'

      toast.error(message)
    }finally{
      setLoading(false)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <SuperAdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>ASSIGN Branch</h1>
        <p className='mt-2 text-sm text-slate-500'>
          Manage and assign branches to admin
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-12'>
        <div className='mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg'>

          <div className="border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg">
            <h2 className="text-lg font-bold text-slate-800">
              Form To Assign Branch
            </h2>
          </div>

          <form 
            onSubmit={handleAssign}
            className='p-6 md:p-8'
          >
            <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
              <div className='mb-6'>
                <label className="block text-sm font-medium">Branch</label>
                <input 
                  type="text"
                  value={branch?.branch_name || ''}
                  disabled
                  className='w-full px-4 p-3 border border-slate-300 rounded-lg'
                />
              </div>

              <div className='mb-8'>
                <label className="block text-sm font-medium">Admin</label>
                <select
                  value={selectedAdmin}
                  onChange={(e) => setSelectedAdmin(e.target.value)}
                  className='w-full px-4 p-3 border border-slate-300 rounded-lg'
                >
                  <option value="">Select Admin</option>
                  {admins.map((admin) => (
                    <option
                      key={admin.id}
                      value={admin.id}
                    >
                      {admin.admin_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
              <button
                type='button'
                onClick={() => navigate('/super_admin/all_branches')}
                className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type='submit'
                disabled={loading}
                className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? 'Assigning...' : 'Assign Branch'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
